import { render, staticRenderFns } from "./Budjet_qonun.vue?vue&type=template&id=f7d3490a&"
import script from "./Budjet_qonun.vue?vue&type=script&lang=js&"
export * from "./Budjet_qonun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports